module.exports = __webpack_public_path__ + "img/sbm2.a4c57586.jpg";